import React from "react";
import ReactPlayer from 'react-player'

function Video() {
  return (
    <div className="font-sans bg-[#111827] h-full flex justify-center items-center">
  <div className='w-full max-w-4xl px-4'>
    <h1 className='text-blue text-[40px] p-5 text-left font-bold text-white flex justify-center mt-10'>
      EDUCATIONAL VIDEOS
    </h1>
    {/* Descriptive Text */}
    <p className="text-white text-lg md:text-xl text-center mb-5">
      Experience 360° videos of immersive environments, allowing players to navigate and explore every detail.
    </p>
    <ul className="list-none p-5">
      <li className="mb-4 text-center">
        <h2 className="text-white text-xl md:text-2xl font-semibold mb-2">
          Dystopian Future Environment 360°
        </h2>
         <p>
          Human-induced environmental degradation without positive interventions
        </p>
        <div className="flex justify-center mt-5">
          <ReactPlayer 
            url='https://youtu.be/J3X-Q20qyzg' 
            className="w-full max-w-3xl" // Optional: Control the size of the player
          />
        </div>
      </li>
      <li className="mb-10 text-center">
        <h2 className="text-white text-xl md:text-2xl font-semibold mb-2">
          Eutopian Future Environment 360°
        </h2>
        <p>
          Flourishing environment with nature-based solutions applied
        </p>
        <div className="flex justify-center mt-5">
          <ReactPlayer 
            url='https://youtu.be/JA88yjiZvA4' 
            className="w-full max-w-3xl" // Optional: Control the size of the player
          />
        </div>
      </li>
      <li className="mb-10 text-center">
        <h2 className="text-white text-xl md:text-2xl font-semibold mb-2">
          Trailer Video
        </h2>
        <div className="flex justify-center">
          <ReactPlayer 
            url='https://youtu.be/pCUL9ece6Gk' 
            className="w-full max-w-3xl" // Optional: Control the size of the player
          />
        </div>
      </li>

      <li className="mb-10 text-center">
        <h2 className="text-white text-xl md:text-2xl font-semibold mb-2">
          Comparative Example Video: Traffic
        </h2>
        <div className="flex justify-center">
          <ReactPlayer 
            url='https://youtu.be/kWqyp9bsNko' 
            className="w-full max-w-3xl" // Optional: Control the size of the player
          />
        </div>
      </li>
      <li className="mb-10 text-center">
        <h2 className="text-white text-xl md:text-2xl font-semibold mb-2">
          Comparative Example Video: Robin
        </h2>
        <div className="flex justify-center">
          <ReactPlayer 
            url='https://youtu.be/kjKIVcAkRz4' 
            className="w-full max-w-3xl" // Optional: Control the size of the player
          />
        </div>
      </li>
      <li className="mb-10 text-center">
        <h2 className="text-white text-xl md:text-2xl font-semibold mb-2">
          Comparative Example Video: Flora 
        </h2>
        <div className="flex justify-center">
          <ReactPlayer 
            url='https://youtu.be/ooI3cea1gSI' 
            className="w-full max-w-3xl" // Optional: Control the size of the player
          />
        </div>
      </li>
      <li className="mb-10 text-center">
        <h2 className="text-white text-xl md:text-2xl font-semibold mb-2">
          Comparative Example Video: Citizens 
        </h2>
        <div className="flex justify-center">
          <ReactPlayer 
            url='https://youtu.be/ufKBO3inGyE' 
            className="w-full max-w-3xl" // Optional: Control the size of the player
          />
        </div>
      </li>
    </ul>
  </div>
</div>



  );
}

export default Video;
